import EventBus from './EventBus';

// Singleton on window so AngularJS (unbundled) and React can share the same bus.
// Remove window.eventBus once Angular is fully migrated.
if (window.eventBus === undefined) {
  window.eventBus = EventBus();
}

const eventBus = window.eventBus;

export default eventBus;
